// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"index_dropdown_37LLp","icon":"index_icon_2dY5o"};